import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=43239b20&scoped=true"
import script from "./StepTitle.vue?vue&type=script&lang=js"
export * from "./StepTitle.vue?vue&type=script&lang=js"
import style0 from "./StepTitle.vue?vue&type=style&index=0&id=43239b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43239b20",
  null
  
)

export default component.exports